import * as z from "zod";
//#region src/__generated__/project-gge/projectMetaController/zod/deleteMetaSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteMetaPathProjectIdSchema = z.uuid();
const deleteMetaPathMetaKeySchema = z.string();
const deleteMetaStatus200Schema = z.unknown();
const deleteMetaResponseSchema = deleteMetaStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/projectMetaController/zod/projectMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectMetaDtoSchema = z.object({
	key: z.string(),
	value: z.string()
}).describe("Project metadata object.");
//#endregion
//#region src/__generated__/project-gge/projectMetaController/zod/getProjectMetaSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getProjectMetaPathProjectIdSchema = z.uuid();
const getProjectMetaStatus200Schema = z.array(projectMetaDtoSchema);
const getProjectMetaResponseSchema = getProjectMetaStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/projectMetaController/zod/setMetaSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const setMetaPathProjectIdSchema = z.uuid();
const setMetaPathKeySchema = z.string();
const setMetaStatus200Schema = projectMetaDtoSchema.describe("Project metadata object.");
const setMetaResponseSchema = setMetaStatus200Schema;
const setMetaDataSchema = projectMetaDtoSchema.describe("Project metadata object.");
//#endregion
export { setMetaStatus200Schema as a, getProjectMetaStatus200Schema as c, deleteMetaPathProjectIdSchema as d, deleteMetaResponseSchema as f, setMetaResponseSchema as i, projectMetaDtoSchema as l, setMetaPathKeySchema as n, getProjectMetaPathProjectIdSchema as o, deleteMetaStatus200Schema as p, setMetaPathProjectIdSchema as r, getProjectMetaResponseSchema as s, setMetaDataSchema as t, deleteMetaPathMetaKeySchema as u };

//# sourceMappingURL=setMetaSchema2.js.map